// Special Reports — parent container for experimental / high-touch
// analyses that don't fit the Agentic Reporting file-download model.
//
// Tabs live here so new special reports can be dropped in without
// growing the sidebar. First tab (and today the only one) is
// Spoke Growth: an animated hub/spoke map with MP4 export.

import React, { useState } from 'react';
import SpokeGrowth from './specialReports/SpokeGrowth';
import FacilityGeocoding from './specialReports/FacilityGeocoding';
import './SpecialReports.css';

const TABS = [
  { id: 'spoke-growth',       label: 'Spoke Growth',       Component: SpokeGrowth },
  { id: 'facility-geocoding', label: 'Facility Geocoding', Component: FacilityGeocoding },
];

function SpecialReports() {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  const ActiveComponent = (TABS.find(t => t.id === activeTab) || TABS[0]).Component;

  return (
    <>
      <div className="special-page-header">
        <div>
          <h1>Special Reports</h1>
          <div className="special-page-sub">
            High-touch analyses that don't fit a plain download.
          </div>
        </div>
      </div>

      <div className="special-tabs" role="tablist">
        {TABS.map(t => (
          <button
            key={t.id}
            role="tab"
            aria-selected={activeTab === t.id}
            className={`special-tab ${activeTab === t.id ? 'active' : ''}`}
            onClick={() => setActiveTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="special-tab-body" role="tabpanel">
        <ActiveComponent />
      </div>
    </>
  );
}

export default SpecialReports;
